<template>
  <div id="scenario-list-list-view" class="data-list-container">
    <div class="vx-row">
      <div class="vx-col md:w-1/2 w-full mt-5">
        <form-label>{{$t('GeoScenarioPage.Project')}}</form-label>
        <v-select
          :options="projects"
          :reduce="project => project.id"
          label="name"
          v-model="projectId"
          class="w-full"
          name="projectId"
        ></v-select>
      </div>
      <div class="vx-col md:w-1/2 w-full mt-5">
        <form-label>{{$t('GeoScenarioPage.BlockModel')}}</form-label>
        <v-select
          :options="blockModels"
          :reduce="blockModel => blockModel.id"
          label="name"
          v-model="blockModelId"
          class="w-full"
          name="blockModelId"
        ></v-select>
      </div>
    </div>
    <div class="vx-row">
      <div class="vx-col w-full mt-5">
        <vs-table
          ref="table"
          v-model="selected"
          @selected="onSelected"
          pagination
          :max-items="itemsPerPage"
          search
          :data="scenarios"
        >
          <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
            <vs-row vs-type="flex" vs-justify="space-between">
              <vs-col vs-type="flex" vs-justify="left" vs-align="center" vs-w="4">
                <vs-button
                  :disabled="!isBlockModelSelected"
                  color="primary"
                  type="border"
                  icon-pack="feather"
                  icon="icon-add"
                  @click="addNewData"
                >{{$t('AddNew')}}</vs-button>
              </vs-col>
              <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="4">
                <Pager
                  :currentPage="currentPage"
                  :itemsPerPage="itemsPerPage"
                  :totalCount="scenarios.length"
                  :queriedItems="queriedItems"
                  :pageSizes="[5,10,15,20]"
                  @pageChanged="onPageChanged"
                ></Pager>
              </vs-col>
              <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="2">
                <div>
                  <form-label>{{$t('GeoScenarioPage.DisplayOnlyMine')}}</form-label>
                  <vs-switch v-model="onlyMine" />
                </div>
              </vs-col>
            </vs-row>
          </div>
          <template slot="thead">
            <vs-th sort-key="name">{{$t('GeoScenarioPage.Name')}}</vs-th>
            <vs-th sort-key="defaultRefiningCost">{{$t('GeoScenarioPage.CNRefiningCharge')}}</vs-th>
            <vs-th sort-key="defaultRoyalties">{{$t('GeoScenarioPage.DefaultRoyalties')}}</vs-th>
            <vs-th sort-key="auPrice">{{$t('GeoScenarioPage.GoldPrice')}}</vs-th>
            <vs-th sort-key="auEstimator">{{$t('GeoScenarioPage.GoldEstimator')}}</vs-th>
            <vs-th sort-key="includeAg">{{$t('Silver')}}</vs-th>
            <vs-th sort-key="includeCu">{{$t('Copper')}}</vs-th>

            <vs-th>{{$t('Action')}}</vs-th>
          </template>

          <template slot-scope="{data}">
            <tbody>
              <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                <vs-td>
                  <p class="scenario-name font-medium truncate">{{ tr.name }}</p>
                </vs-td>
                <vs-td>
                  <p class="scenario-name font-medium truncate">{{ tr.defaultRefiningCost }}</p>
                </vs-td>
                <vs-td>
                  <p class="scenario-name font-medium truncate">{{ tr.defaultRoyalties }}</p>
                </vs-td>
                <vs-td>
                  <p class="scenario-name font-medium truncate">{{ tr.auPrice }}</p>
                </vs-td>
                <vs-td>
                  <p
                    class="scenario-name font-medium truncate"
                  >{{ getEstimatorDescription(tr.auEstimator) }}</p>
                </vs-td>
                <vs-td>
                  <vs-checkbox disabled="true" v-model="tr.includeAg"></vs-checkbox>
                </vs-td>
                <vs-td>
                  <vs-checkbox disabled="true" v-model="tr.includeCu"></vs-checkbox>
                </vs-td>
                <vs-td width="100px" class="whitespace-no-wrap">
                  <feather-icon
                    icon="EditIcon"
                    svgClasses="w-5 h-5 hover:text-primary stroke-current"
                    @click.stop="editData(tr)"
                  />
                  <feather-icon
                    icon="TrashIcon"
                    svgClasses="w-5 h-5 hover:text-danger stroke-current"
                    class="ml-2"
                    @click.stop="openDeleteConfirm(tr.id, tr.name)"
                  />
                </vs-td>
              </vs-tr>
            </tbody>
          </template>
        </vs-table>
      </div>
    </div>
  </div>
</template>
<script>
import moduleScenarioList from "@/store/geo/scenarios/moduleScenarioList.js";
import moduleProjectList from "@/store/geo/projects/moduleProjectList.js";
import vSelect from "vue-select";
import { FormLabel, Pager } from "../../../shared/components";

export default {
  components: {
    vSelect,
    FormLabel,
    Pager
  },
  data() {
    return {
      selected: [],
      itemsPerPage: 5,
      isMounted: false,
      projectId: null,
      blockModelId: null,
      currentUser: null,
      onlyMine: true,
      userInfo: null
    };
  },
  async beforeMount() {
    const res = await this.$graphApi.get("/me");
    this.userInfo = res.data;
  },

  computed: {
    currentPage() {
      if (this.isMounted) {
        return this.$refs.table.currentx;
      }
      return 0;
    },
    scenarios() {
      if ((this.blockModelId !== null) & (this.blockModelId !== 0)) {
        return this.$store.state.scenarioList.scenarios.filter(
          s => s.blockModelId === this.blockModelId && (!this.onlyMine || s.createdBy === this.userInfo.userPrincipalName)
        );
      } else return [];
    },
    projects() {
      return this.$store.state.geoProjectList.projects;
    },
    blockModels() {
      if ((this.projectId !== null) & (this.projectId !== 0))
        return this.$store.state.geoProjectList.projects.find(
          project => project.id === this.projectId
        ).blockModels;
      else return [];
    },
    queriedItems() {
      return this.$refs.table
        ? this.$refs.table.queriedResults.length
        : this.scenarios.length;
    },
    isBlockModelSelected() {
      return this.blockModelId !== null;
    }
  },
  watch: {
    projectId(val) {
      if (!val) return;

      this.blockModelId = null;
      this.selected = null;
    }
  },
  methods: {
    onPageChanged(val) {
      this.itemsPerPage = val;
    },
    addNewData() {
      this.$emit("onCreateScenario", this.blockModelId);
    },
    editData(data) {
      this.$emit("onEditScenario", data);
    },
    openDeleteConfirm(id, name) {
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: name,
        text: this.$t('GeoScenarioPage.ConfirmDelete', { scenarioName: name }),
        accept: this.deleteData,
        parameters: [id]
      });
    },
    getEstimatorDescription(estimatorId) {
      /*eslint indent: [0, "spaces", {indentSwitchCase: true}]*/
      switch (estimatorId) {
        case 0:
          return "Ordinary Kriging";
        case 1:
          return "Nearest Neighbor";
        case 2:
          return "Inverse Power";
        case 3:
          return "Uncapped O Krig";
        case 4:
          return "Simple Kriging";
        case 5:
          return "Sichel T Est";
        default:
          return "undefined";
      }
    },
    deleteData(parameters) {
      this.$store
        .dispatch("scenarioList/removeItem", parameters[0])
        .then(() => {
          this.$vs.notify({
            color: "danger",
            title: this.$t("Success"),
            text: this.$t("GeoScenarioPage.ScenarioDeleted")
          });
        });
    },
    onSelected(data) {
      this.$emit("onScenarioSelected", data);
    }
  },
  created() {
    if (!moduleProjectList.isRegistered) {
      this.$store.registerModule("geoProjectList", moduleProjectList);
      moduleProjectList.isRegistered = true;
    }
    this.$store.dispatch("geoProjectList/fetchProjectListItems");

    if (!moduleScenarioList.isRegistered) {
      this.$store.registerModule("scenarioList", moduleScenarioList);
      moduleScenarioList.isRegistered = true;
    }
    this.$store.dispatch("scenarioList/fetchScenarioListItems");
  },
  mounted() {
    this.isMounted = true;
  }
};
</script>

<style lang="scss">
#scenario-list-list-view {
  .vs-con-table {
    /*
      Below media-queries is fix for responsiveness of action buttons
      Note: If you change action buttons or layout of this page, Please remove below style
    */
    @media (max-width: 689px) {
      .vs-table--search {
        margin-left: 0;
        max-width: unset;
        width: 100%;

        .vs-table--search-input {
          width: 100%;
        }
      }
    }

    @media (max-width: 461px) {
      .items-per-page-handler {
        display: none;
      }
    }

    @media (max-width: 341px) {
      .data-list-btn-container {
        width: 100%;

        .dd-actions,
        .btn-add-new {
          width: 100%;
          margin-right: 0 !important;
        }
      }
    }

    .vs-table--header {
      display: flex;
      flex-wrap: wrap;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search {
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          & + i {
            left: 1rem;
          }

          &:focus + i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 0.8rem;
      padding: 0 1rem;

      tr {
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);
        td {
          padding: 8px;
          &:first-child {
            border-top-left-radius: 0.5rem;
            border-bottom-left-radius: 0.5rem;
          }
          &:last-child {
            border-top-right-radius: 0.5rem;
            border-bottom-right-radius: 0.5rem;
          }
        }
      }
    }

    .vs-table--thead {
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text {
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check {
        padding: 0 15px !important;
      }
      tr {
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--tbody-table {
      min-width: 200px;
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}
</style>